import PropTypes from 'prop-types';
import React from 'react';

function VideoListHeader(props) {
  const {
    heading,
    headingURL,
    description,
    show,
  } = props;
  if (!show) {
    return null;
  }

  const hasHeading = !!heading;
  const hasDescription = !!description;

  return (
    <header className="ontheshow__video-list-header">
      {hasHeading && (
        <a href={headingURL} className="ontheshow__video-list-header-link">
          <h2 className="ontheshow__video-list-header-heading">{ heading }</h2>
        </a>
      )}
      {hasDescription && (
        <p className="ontheshow__video-list-header-description">{ description }</p>
      )}
    </header>
  );
}

VideoListHeader.propTypes = {
  heading: PropTypes.string,
  headingURL: PropTypes.string,
  description: PropTypes.string,
  show: PropTypes.bool,
};

VideoListHeader.defaultProps = {
  heading: undefined,
  headingURL: undefined,
  description: undefined,
  show: true,
};

export default VideoListHeader;
